import { v4 as uuid } from 'uuid';

import { money } from 'hb-react/shared/apps/Memberships/utils/money';
import {
  CART_ITEM_TYPES,
  SUB_CART_ITEM_TYPES,
} from 'hb-react/shared/components/ShoppingCard/constants/cartConstants';

const getTicket = (ticket, ticketUuid) => {
  const { ticketHolder } = ticket;

  return {
    type: CART_ITEM_TYPES.TICKET,
    line_itemable_id: ticket.ticket_id,
    quantity: 1,
    metadata: {
      event: {
        ...ticket,
        uuid: ticketUuid,
        ticket_holder: ticketHolder,
        parent_uuid: null,
        type: SUB_CART_ITEM_TYPES.TICKET,
      },
    },
  };
};

const getPromoCode = (promoCode) => ({
  type: CART_ITEM_TYPES.PROMO_CODE,
  line_itemable_id: promoCode.line_itemable_id,
});

const getSubAddon = (addon, ticket, ticketUuid) => {
  const {
    email,
    firstname,
    lastname,
    user_id: userId,
    guest_id: guestId,
    ticket_id: ticketId,
    ticketHolder,
  } = ticket;
  const { id, ...restAddon } = addon;

  return {
    type: CART_ITEM_TYPES.EVENT_ADDON,
    line_itemable_id: id,
    quantity: restAddon.quantity,
    metadata: {
      event: {
        ...restAddon,
        addon_id: id,
        email,
        firstname,
        lastname,
        user_id: userId,
        guest_id: guestId,
        ticket_id: ticketId,
        ticket_holder: ticketHolder,
        uuid: uuid(),
        parent_uuid: ticketUuid,
        type: SUB_CART_ITEM_TYPES.SUB_ADDON,
      },
    },
  };
};

export const getTicketsAndSubAddons = (attendees) => {
  const result = [];

  attendees.forEach((attendee) => {
    const { addons_attributes: addonsAttributes, ...ticket } = attendee;

    const ticketUuid = uuid();
    const ticketCartItem = getTicket(ticket, ticketUuid);

    result.push(ticketCartItem);

    addonsAttributes
      .filter(({ quantity = 0 }) => quantity && quantity > 0)
      .forEach((addon) => {
        const subAddonCartItem = getSubAddon(addon, ticket, ticketUuid);

        result.push(subAddonCartItem);
      });
  });

  return result;
};

export const getDonations = (
  donations,
  currency,
  flagEvCurrenciesWithoutCents,
) =>
  donations
    .filter(({ amount = 0 }) => amount && amount > 0)
    .map(({ id, ...donationRest }) => ({
      type: CART_ITEM_TYPES.DONATION,
      line_itemable_id: id,
      total_in_cents: money(
        donationRest.amount,
        currency?.code,
        flagEvCurrenciesWithoutCents,
      ).cents,
      metadata: {
        event: {
          ...donationRest,
          type: SUB_CART_ITEM_TYPES.DONATION,
        },
      },
    }))
    .filter(Boolean);

export const getStandaloneAddons = (addons, attendee) =>
  addons
    .filter(({ quantity = 0 }) => quantity > 0)
    .map(({ id, ...restAddon }) => ({
      type: CART_ITEM_TYPES.EVENT_ADDON,
      line_itemable_id: id,
      quantity: 1,
      metadata: {
        event: {
          ...restAddon,
          email: attendee.email,
          firstname: attendee.firstname,
          lastname: attendee.lastname,
          user_id: attendee.user_id,
          guest_id: attendee.guest_id,
          addon_id: id,
          type: SUB_CART_ITEM_TYPES.STANDALONE_ADDON,
        },
      },
    }))
    .filter(Boolean);

export const getPromoCodes = (promoCodes) =>
  promoCodes.map((promoCode) => getPromoCode(promoCode));

export const transformFormStateToOrder = ({
  eventsBooking = {},
  receipt = {},
  currency,
  promoCodes = [],
  flagEvCurrenciesWithoutCents,
}) => {
  const {
    attendees_attributes: attendeesAttributes = [],
    donations_attributes: donationsAttributes = [],
    addons_attributes: addonsAttributes = [],
  } = eventsBooking;

  const ticketsAndSubAddons = getTicketsAndSubAddons(attendeesAttributes);
  const donations = getDonations(
    donationsAttributes,
    currency,
    flagEvCurrenciesWithoutCents,
  );
  const standaloneAddons = getStandaloneAddons(
    addonsAttributes,
    attendeesAttributes[0],
  );

  const promoCodesCartItem = getPromoCodes(promoCodes);

  const {
    lastname,
    firstname,
    email,
    address_type: addressType,
    ...userInfoRest
  } = receipt;

  return {
    cart: {
      cart_items: [
        ...ticketsAndSubAddons,
        ...standaloneAddons,
        ...donations,
        ...promoCodesCartItem,
      ],
      currency,
      ...(addressType && { postal_address_type: addressType }),
      ...userInfoRest,
    },
    user: { lastname, firstname, email },
  };
};
